export default {
  title: {
    en: 'We think you might like…',
  },
  buttonTitle: {
    en: 'See more products',
  },
  mobileButtonTitle: {
    en: 'My subscription queue',
  },
}
